import React from "react";
import Acclimatation from "./Acclimatation";
import Preparation from "./Preparation";
import TypeIntervention from "./TypeIntervention";
import { Box, Stack, Chip } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

function ExperimentForm({ index, data, setData }) {
  if (!data[index]) {
    return <div style={{ padding: "2rem" }}>Loading project data...</div>;
  }
    // Function to add a new intervention at a specific position
  const handleAddIntervention = (position) => {
    const newData = [...data]; // Make a shallow copy of the data array to avoid mutating the state directly
    const interventions = [...newData[index].interventions]; // Copy the interventions array of the current experiment
    // Insert a new intervention object right after the current position
    // The new intervention is initialized with 'lastIntervention: "yes"' by default
    interventions.splice(position + 1, 0, { lastIntervention: "yes" });
    newData[index].interventions = interventions; // Update the interventions array in the copied data
    setData(newData); // Update the state with the new data
  };

  // Function to delete an intervention at a specific position
  const handleDeleteIntervention = (position) => {
    const newData = [...data]; 
    const interventions = [...newData[index].interventions]; // Copy the interventions array of the current experiment
    if (interventions.length > 1) { // Only allow deletion if there is more than one intervention
      interventions.splice(position, 1); // Remove the intervention at the specified position
      newData[index].interventions = interventions; // Update the interventions array
      setData(newData); // Update the state with the new data
    }
  };

  return (
    <div>
      <Acclimatation index={index} data={data} setData={setData} />
      <Preparation index={index} data={data} setData={setData} />

      {data[index].interventions.map((intervention, indexIntervention) => (
        <Box
          key={indexIntervention}
          sx={{
            mt: indexIntervention > 0 ? 3 : 0,
            p: 2,
            border: "1px solid #ccc",
            borderRadius: 2,
          }}
        >
          <TypeIntervention
            index={index}
            data={data}
            setData={setData}
            indexIntervention={indexIntervention}
          />

          <Stack direction="row" spacing={1} mt={2} justifyContent="flex-end">
            <Chip
              onClick={() => handleAddIntervention(indexIntervention)}
              icon={
                <AddCircleOutlineIcon
                  fontSize="small"
                  sx={{ color: indexIntervention === data[index].interventions.length - 1 ? "grey.400" : "primary.main" }}
                />
              }
              variant="contained"
              sx={{ borderColor: "grey.400", "&:hover": { backgroundColor: "grey.100" } }}
              disabled={indexIntervention === data[index].interventions.length - 1}
            />
            <Chip
              onClick={() => handleDeleteIntervention(indexIntervention)}
              icon={
                <DeleteOutlineIcon
                  fontSize="small"
                  sx={{ color: data[index].interventions.length === 1 ? "grey.400" : "error.main" }}
                />
              }
              variant="contained"
              sx={{ borderColor: "grey.400", "&:hover": { backgroundColor: "grey.100" } }}
              disabled={data[index].interventions.length === 1}
            />
          </Stack>
        </Box>
      ))}
    </div>
  );
}

export default ExperimentForm;
